import { BigFormRow } from 'framework/ui/layout';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { TimelineNoteWysiwygInput } from 'domain/shared/core/input';

const VendorNoteForm = () => (
  <>
    <BigFormRow>
      <TimelineNoteWysiwygInput artifactsSource="attachments" source="text" />
    </BigFormRow>
    <BigFormRow>
      <NoteAttachmentUploaderInput isNewDocumentStorage label="Attachments" source="attachments" />
    </BigFormRow>
  </>
);

export default VendorNoteForm;
